import { render, staticRenderFns } from "./ViolationEmployee.vue?vue&type=template&id=268be70e&scoped=true&"
import script from "./ViolationEmployee.vue?vue&type=script&lang=js&"
export * from "./ViolationEmployee.vue?vue&type=script&lang=js&"
import style0 from "./ViolationEmployee.vue?vue&type=style&index=0&id=268be70e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268be70e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCol,VDatePicker,VMenu,VRow,VTextField,VTextarea})
